import { createFileRoute } from "@tanstack/react-router";
import { ProcurementCalendarDetailsPage } from "@/pages/procurement-calendar-details";
import { searchParams } from "@/pages/procurement-calendar-details/model/search-params";
import { preloadCompanyWorkflowsQuery } from "@/features/workflow-dropdown";

export const Route = createFileRoute("/_authed/$companySlug/horizon/$itemId/")({
  component: ProcurementCalendarDetailsPage,
  validateSearch: searchParams,
  loader: ({ context }) => {
    // company is guaranteed by $companySlug beforeLoad redirect guard
    if (context.company) {
      void preloadCompanyWorkflowsQuery(context.company.id);
    }
  },
});
